/** Фильтр строк предпросмотра импорта (кнопки над таблицей). */
export type TImportRowFilter = 'all' | 'errors' | 'warnings' | 'skipped'

/** Значение параметра status ручки GET .../rows/. */
export type TImportRowsStatus = 'all' | 'error' | 'warning' | 'skipped'

export const IMPORT_ROW_FILTER_TO_STATUS: Record<TImportRowFilter, TImportRowsStatus> = {
  all: 'all',
  errors: 'error',
  warnings: 'warning',
  skipped: 'skipped',
}
